/* eslint-disable */
import React, { useCallback, useEffect, useRef } from 'react';
import { Card, CardContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';

import { VariableSizeList as LoadDataList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { useWindowResize } from '../../utility/useWindowResize';
import ParticipantRow from './rows/participantRow';
import AllotmentRow from './rows/allotmentRow';
import InvitationRow from './rows/invitationRow';
 
const theme = createTheme();

const useStyles = makeStyles(() => ({
    cardPaperContent: {
        // boxShadow:
            // '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
        // boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 15px 0px',
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(1, 1, 1, 0),
        backgroundColor: '#fff',
    },
    cardContent: {
        padding: theme.spacing(0.5, 0),
        '&:last-child': {
            paddingBottom: theme.spacing(0.5),
        },
    },
    addPadding: {
        margin: theme.spacing(1, 0),
    },
    addTopPad: {
        padding: theme.spacing(1, 0.5),
    },
    cardRowContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',
    },
    headRowContent: {
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '100%',
        width: '100%',
        alignItems: 'center',
    },
    wrapAll: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '20ch',
    },
}));

const WindowDataList = (props) => {
    const classes = useStyles();
    const { data } = props;
    const listRef = useRef();

    const sizeMap = useRef({});
    const setSize = useCallback((index, size) => {
        sizeMap.current = { ...sizeMap.current, [index]: size };
        listRef.current.resetAfterIndex(index);
    }, []);
    const getSize = index => sizeMap.current[index] || 60;
    const [windowWidth] = useWindowResize();

    const Row = ({ data, index, setSize, windowWidth }) => {
        const rowRef = useRef();
        useEffect(() => {
            setSize(index, rowRef.current.getBoundingClientRect().height);
        }, [setSize, index, windowWidth]);

        const item = data[index];

        return (
            <div ref={rowRef} className={classes.addTopPad}>
                <Card
                    classes={{ root: classes.cardPaperContent }}
                    sx={{ width: '100%' }}>
                    <CardContent sx={{ p: 2 }} className={classes.cardContent}>
                        {props.rowType == 'participant' 
                        ? (<ParticipantRow 
                            classes={classes}
                            item={item}
                            index={index}
                            {...props}
                        />)
                        : props.rowType == 'allotment' 
                        ? (<AllotmentRow 
                            classes={classes}
                            item={item}
                            index={index}
                            key={index}
                            {...props}
                        />)
                        : props.rowType == 'invitation' 
                        ? (<InvitationRow 
                            classes={classes}
                            item={item}
                            index={index}
                            {...props}
                        />)                         
                        : null}
                    </CardContent>
                </Card>
            </div>
        )
    }

    return (
        <>
            {/* <h3>inside</h3> */}
            <div style={{ display: 'flex', height: '68vh' }}>
                <div style={{ flex: '1 1 auto' }}>
                    <AutoSizer>
                        {({ height, width }) => (
                            <LoadDataList
                                ref={listRef}
                                itemData={data}
                                className="List"
                                height={height}
                                itemCount={data.length}
                                itemSize={getSize}
                                width={width}
                            >
                                {({ data, index, style }) => (
                                    <div style={style} className={classes.addPadding}>
                                        <Row
                                            data={data}
                                            index={index}
                                            setSize={setSize}
                                            windowWidth={windowWidth}
                                        />
                                    </div>
                                )}
                                {/* {Row} */}
                            </LoadDataList>
                        )}
                    </AutoSizer>
                </div>
            </div>
        </>
    )
}

export default WindowDataList;